import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Sun Nov 04 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { GridSettingsConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var GridSettingsLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(GridSettingsLayer, _CRUTransportLayer);

  function GridSettingsLayer() {
    _classCallCheck(this, GridSettingsLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsLayer).call(this, CONSTANTS.API.ENDPOINTS.GRID_SETTINGS));
  }

  _createClass(GridSettingsLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Get all GridSettings for the user
     * @returns GridSettings[]
     */

  }, {
    key: "getAll",
    value: function getAll(gridId) {
      var _this = this;

      var getAllPromise = api("".concat(this.baseUri, "/").concat(gridId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data && response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getAllPromise;
    }
  }, {
    key: "delete",
    value: function _delete(gridId) {
      var deletePromise = api("".concat(this.baseUri, "/").concat(gridId)).delete().then(function (response) {
        return response && response.data ? response.data.result : false;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return deletePromise;
    }
  }]);

  return GridSettingsLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", GridSettingsConverter)], GridSettingsLayer.prototype, "converter", void 0);